import api from './api';

export const getLocationUsers = (params) => api.get('/v1/location-users', { params });
// config is forwarded to axios as-is (e.g. { skipErrorToast: true }) — the single
// caller (LocationEmployeesTab) needs to suppress the interceptor's toast on the
// first attempt so it can branch on the 409 itself and open a move-confirmation
// dialog, then retry without it so the retry's outcome surfaces normally.
export const createLocationUser = (data, config) => api.post('/v1/location-users', data, config);
export const deleteLocationUser = (id) => api.delete(`/v1/location-users/${id}`);
export const batchDeleteLocationUsers = (ids) => api.post('/v1/location-users/batch-delete', { ids });
